require('babel-polyfill')

exports.onClientEntry = () => {
  // Dont's need to do anything here, but if you don't
  // exports something, the require won't work
}
